export const AnalyticsEvents = {
  Login: 'login',
  Navigation: 'navigation',
  CourtMessage: 'message',
  SuccessfulPayment: 'successful_payment',
  SourceUrl: 'source',
} as const;

export const AnalyticsCategories = {
  Login: 'auth',
  Navigation: 'navigation',
  CourtMessage: 'message',
  SuccessfulPayment: 'payment',
  SourceUrl: 'source',
} as const;

export const AnalyticsLabels = {
  Login: 'login',
  Navigation: 'navigation',
  CourtMessage: 'message',
  SuccessfulPayment: 'payment',
  SourceUrl: 'source',
} as const;

export const AnalyticsDescriptions = {
  Login: 'User logged in',
  Navigation: 'Navigation item click',
  CourtMessage: 'Message to Court sent',
  SuccessfulPayment: 'Payment successful',
  SourceUrl: 'User source url',
} as const;
